export title = "The <b>modern</b> approach to business cards"

export inclusions = """
Get <b>a revolutionary digital card</b>.
"""

export body = "Leave a lasting impression on your clients with the new way to present yourself.
<br /><br /><br />
#{inclusions}"

export cta = "Start your free trial"

BUNDLE_PRICE_ORIGINAL = +process.env.DIGITAL_CARD_PRICE_ORIGINAL
BUNDLE_PRICE_CURRENT = +process.env.DIGITAL_CARD_PRICE_CURRENT

export price =
	current: BUNDLE_PRICE_CURRENT
	previous: BUNDLE_PRICE_ORIGINAL
	label: 'Early-bird special'

export altProduct = "Or get 1 digital card for $100"